import { pnpLogo } from "../../../Asserts";
import useDeviceType from "../../../Utiles/FindDevice";
import { useFormik } from "formik";
import { emailValidationSchema } from "../../../Validation/formValidation";
import { useNavigate } from "react-router";
import axios from "axios";
import { baseURL } from "../../../services/axiosConfig";
import { toast } from "react-toastify";
import { FooterTab, MobileFooter } from "../../../../Components/GreenHome/Footer";

const V2ForgotPassword = () => {
  const deviceType = useDeviceType();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: emailValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await axios.post(`${baseURL}/accounts/forgot_password`, {
          email: values.email
        });
        navigate(`/emailVerification/${values.email}`, { state: { from: "forgotPassword" } });
      } catch (error) {
        let errorMessage = "An error occurred. Please try again.";

        if (error?.response?.status === 404) {
          errorMessage = "We couldn’t find an account with this email.";
        } else if (
          error?.response?.data?.status === "Error" &&
          error?.response?.data?.message
        ) {
          if (
            error.response.data.message.toLowerCase().includes("email not found") ||
            error.response.data.message.toLowerCase().includes("no account")
          ) {
            errorMessage = "We couldn’t find an account with this email.";
          } else {
            errorMessage = error.response.data.message;
          }
        } else if (error?.message) {
          errorMessage = error.message;
        }

        toast.error(errorMessage);
        console.error("Error in forgotPasswordHandler:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-2px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
      `}</style>
      <div 
        style={{
          backgroundImage: `url('/v2/images/bg/${
            deviceType === "mobile" ? "auth-bg-mobile.png" : "auth-bg.png"
          }')`,
        }}
        className="bg-cover bg-no-repeat bg-center min-h-screen overflow-hidden flex flex-col justify-between"
      >
        <div
          className={`flex ${
            deviceType === "mobile"
              ? "flex-col py-16"
              : "lg:flex-row justify-between px-24 py-[58px]"
          } bg-cover bg-no-repeat bg-center items-start`}
        >
          {deviceType !== "mobile" && (
            <div className={`text-white`}>
              <a href="/"><img src={pnpLogo} alt="Logo" className="h-28 lg:h-44 mb-6 md:-my-6" /></a>
            </div>
          )}

          <div
            className={`flex flex-col ${
              deviceType === "mobile" ? "w-full px-6" : "h-full"
            } items-center justify-center`}
          >
            {deviceType === "mobile" && (
              <a href="/">
                <img src={pnpLogo} alt="Logo" className="h-32 w-auto mb-6" />
              </a>
            )}
            <div
              className={`bg-white rounded-b-[12px] rounded-t-[6.5px] ${
                deviceType === "mobile"
                  ? "w-[100%] mx-auto my-8"
                  : deviceType === "tablet"
                  ? "w-[350px] max-w-[550px]"
                  : deviceType === "laptop"
                  ? "w-[450px] max-w-[500px] h-full"
                  : "w-[440px] max-w-[500px] h-full"
              }`}
            >
              <div
                className={`bg-gradient-to-r h-[6px] rounded-t-[12px] from-[#00C05B] to-[#007FFF] w-full`}
              ></div>
              <div className="flex justify-center items-center h-full">
                <div className="w-full">
                  <div
                    className={`${
                      deviceType === "mobile"
                        ? "px-6 py-8"
                        : deviceType === "tablet"
                        ? "px-10 py-12"
                        : "px-10 py-16"
                    }`}
                  >
                    <h2
                      className={`text-xl font-archivo font-bold text-[#0081F8] lg:text-[24px]  lg:mx-8 justify-start`}
                    >
                      Forgot your password?
                    </h2>
                    <p className={`text-[12.5px] md:text-[16px] text-black/60 mt-2 mb-6 font-inter lg:mx-8 justify-start `}>
                      Please enter the email address you
                      <p>would like to reset password</p>
                    </p>
                    <form onSubmit={formik.handleSubmit} noValidate className="md:mt-2 lg:mt-1">
                      <div className="lg:w-72 lg:mx-8">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className={`mb-2 px-4 py-2.5 border placeholder-black/50 border-[#00000033] rounded-full focus:outline-none w-full ${
                            deviceType === "mobile"
                              ? "mt-2"
                              : deviceType === "desktop"
                              ? "mt-8"
                              : ""
                          } ${formik.touched.email && formik.errors.email ? "border-red-500" : ""}`}
                        />
                        <div className={`${deviceType === "mobile" ? "h-2" : "h-2"}`}>
                          {formik.touched.email && formik.errors.email && (
                            <p className="text-red-500 text-xs font-medium animate-fadeIn">
                              {formik.errors.email}
                            </p>
                          )}
                        </div>
                      </div>

                      <div
                        className={`flex items-center md:mt-4 ${
                          deviceType === "mobile"
                            ? "text-[14px] mt-2"
                            : deviceType === "desktop"
                            ? "text-[16px] mt-8"
                            : ""
                        } justify-between`}
                      >
                        <button
                          type="submit"
                          disabled={formik.isSubmitting}
                          className={`bg-[#0081F8] lg:mx-8 hover:bg-[#0081F8] font-inter ${
                            deviceType === "mobile"
                              ? "text-[14px] w-full"
                              : "text-[16px] w-72"
                          } text-white py-3 rounded-full disabled:bg-gray-400 disabled:cursor-not-allowed`}
                        >
                          {formik.isSubmitting ? "Sending..." : "Send Verification Code"}
                        </button>
                      </div>

                      <div className={`flex md:mx-4 lg:mx-5 mt-4 ${deviceType === "mobile" ? "text-[12.5px]" : "text-[16px]"}`}>
                        <p className={`text-center ${
                            deviceType === "mobile"
                              ? "text-[12px] mt-3"
                              : deviceType === "desktop"
                              ? "text-[16px] mt-8"
                              : ""
                          } text-[#000000B2]`}>Remember your password?                  
                          <span 
                            className="text-green-600 ml-2 cursor-pointer font-semibold underline hover:underline"
                            onClick={() => navigate("/login")}
                          >
                            Back to Login
                          </span>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         {deviceType === "mobile" ?
             <MobileFooter /> :
              <FooterTab component="privacyPolicy" className="mt-auto" />
             }
      </div>
    </>
  );
};

export default V2ForgotPassword;